export default {
  setServiceAccounts (state, payload) {
    state.list = payload
  }
}